/**
 * Evento de acionamento de passos globais (espelha API chatbotSlotEvent).
 */

export const EVENTO_IDENTIFICADOR = "identificador";
export const EVENTO_INATIVIDADE = "inatividade";

export function defaultSlotEvento() {
  return { tipo: EVENTO_IDENTIFICADOR };
}

export function normalizeSlotEvento(raw) {
  if (!raw || typeof raw !== "object") return defaultSlotEvento();
  const tipo = String(raw.tipo || EVENTO_IDENTIFICADOR).trim().toLowerCase();
  if (tipo === EVENTO_INATIVIDADE) {
    const minutos = Number(raw.minutos_inatividade ?? raw.minutos ?? 0);
    return {
      tipo: EVENTO_INATIVIDADE,
      minutos_inatividade: Number.isFinite(minutos) && minutos > 0 ? Math.round(minutos) : 3,
    };
  }
  return defaultSlotEvento();
}

export function eventoFromSlot(slot) {
  if (slot?.evento) return normalizeSlotEvento(slot.evento);
  return defaultSlotEvento();
}

export function eventoToPayload(evento) {
  const normalized = normalizeSlotEvento(evento);
  if (normalized.tipo === EVENTO_IDENTIFICADOR) return null;
  return normalized;
}

export function eventoLabel(evento) {
  const e = normalizeSlotEvento(evento);
  if (e.tipo === EVENTO_INATIVIDADE) {
    return `Inatividade (${e.minutos_inatividade} min)`;
  }
  return "Identificador";
}
